import React, { Component } from "react";
import { Link } from "react-router-dom";
import { TEXT_LABELS } from "../common/configTable";
import MUIDataTable from "mui-datatables";
import { Typography, Tooltip } from "@material-ui/core";
import ButtonAdd from "../common/buttonAdd";
import DeleteIcon from "@material-ui/icons/Delete";
import ThemeContainer from "../common/ThemeProvider";
import EditIcon from "@material-ui/icons/Edit";
import auth from "../../auth/authService";
import { ROLES } from "../../utils/constants";

class UsersTable extends Component {
  render() {
    const { datas, onDelete } = this.props;
    let columns = [
      {
        name: "count",
        label: "#",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1,
        },
      },
      {
        name: "id",
        label: "id",
        options: {
          filter: false,
          display: "excluded",
        },
      },
      {
        name: "updated_at",
        label: "Fecha actualización",
        options: {
          filter: false,
          sort: false,
          display: "excluded",
        },
      },
      {
        name: "identification_card",
        label: "Cédula",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "fullname",
        label: "Nombre",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "email",
        label: "Correo electrónico",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "level",
        label: "Nivel",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "belongs_espoch",
        label: "Pertenece ESPOCH",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => (value === 1 ? "SÍ" : "NO"),
        },
      },
      {
        name: "roles",
        label: "Roles",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            let nameRoles = value.map((v) => v.name);
            return <React.Fragment>{nameRoles.join(", ")}</React.Fragment>;
          },
        },
      },
      {
        name: "human_updated_at",
        label: "Última actualización",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value, tableMeta) => {
            return (
              <Tooltip
                title={`${tableMeta.rowData[2]}`}
                style={{ cursor: "pointer" }}
              >
                <span>{`${value}`}</span>
              </Tooltip>
            );
          },
        },
      },
      {
        name: "acciones",
        label: "Acciones",
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            return (
              <React.Fragment>
                <Tooltip title="Editar" style={{ cursor: "pointer" }}>
                  <Link
                    style={{ textDecoration: "none" }}
                    to={`/usuario/${tableMeta.rowData[1]}`}
                  >
                    <EditIcon color={"primary"} />
                  </Link>
                </Tooltip>
                <Tooltip title="Eliminar" style={{ cursor: "pointer" }}>
                  <DeleteIcon
                    onClick={() => onDelete(tableMeta.rowData[1])}
                    color={"primary"}
                  />
                </Tooltip>
              </React.Fragment>
            );
          },
        },
      },
    ];
    const options = {
      filterType: "dropdown",
      responsive: "scroll",
      rowsPerPage: 20,
      rowsPerPageOptions: [5, 10, 20],
      selectableRows: "none",
      textLabels: TEXT_LABELS,
    };

    columns =
      auth.getSelectedRole().name !== ROLES.CIMOGSYS
        ? columns.filter(
            (col) => col.name !== "roles" && col.name !== "acciones"
          )
        : columns;

    return (
      <ThemeContainer>
        <MUIDataTable
          title={
            <Typography variant="h6">
              Lista de usuarios <ButtonAdd entity={"usuario"} />
            </Typography>
          }
          data={datas}
          columns={columns}
          options={options}
        />
      </ThemeContainer>
    );
  }
}

export default UsersTable;
